import React, { useState } from "react";
import { Link } from "react-scroll";

import * as S from "./styles";
import { headerMobileHeight } from "./styles";

import Logo from "../../assets/logo_black_mob.png";

import Button from "../../components/button";

const HeaderMobile = () => {
  const [openMenu, setOpenMenu] = useState(false);

  const toggleMenu = () => {
    setOpenMenu(!openMenu);
  };

  return (
    <S.HeaderMobile openMenu={openMenu}>
      <img
        src={Logo}
        alt='logo'
        onClick={() => (window.location.href = "https://estacio.br/")}
      />
      <Link
        href="#!"
        activeClass={'active'}
        to="toRegisterMobile"
        smooth={true}
        offset={-headerMobileHeight}
        onClick={()=> setOpenMenu(false)}>
        <Button
          label='CADASTRE-SE'
          fontSize='13'
          height='32'
          width='132'
        />
      </Link>
      
      <button className='btn-menu' onClick={toggleMenu}>
        <span></span>
        <span></span>
        <span></span>
      </button>
      <nav className='nav-menu'>
        <ul className='menu'>
          <li>
            <Link
              href="#!"
              activeClass={'active'}
              to="toMission"
              smooth={true}
              offset={-headerMobileHeight}
              onClick={()=> setOpenMenu(false)}>
              Expedição ENEMVERSO
            </Link>
          </li>
          <li>
            <Link
              href="#!"
              activeClass={'active'}
              to="toManual"
              smooth={true}
              offset={-72.5}
              onClick={()=> setOpenMenu(false)}>
              E-book
            </Link>
          </li>
          <li>
            <Link
              href="#!"
              activeClass={'active'}
              to="toExtra"
              smooth={true}
              offset={-headerMobileHeight}
              onClick={()=> setOpenMenu(false)}>
              Conteúdos extras
            </Link>
          </li>
          <li>
            <Link
              href="#!"
              activeClass={'active'}
              to="toDoubts"
              smooth={true}
              offset={-headerMobileHeight}
              onClick={()=> setOpenMenu(false)}>
              Dúvidas
            </Link>
          </li>
          <li>
            <Link
              href="#!"
              activeClass={'active'}
              to="toRegisterMobile"
              smooth={true}
              offset={-headerMobileHeight}
              onClick={()=> setOpenMenu(false)}>
              Cadastre-se
            </Link>
          </li>
          <li>
            <Link
              href="#!"
              activeClass={'active'}
              to="alreadyRegistered"
              smooth={true}
              offset={-(headerMobileHeight + 20)}
              onClick={()=> setOpenMenu(false)}>
              Já sou cadastrado
            </Link>
          </li>
        </ul>
      </nav>
    </S.HeaderMobile>
  );
};

export default HeaderMobile;
